<template>
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      width="50%"
      title="门店联营分成比例设置"
      :close-on-click-modal="false"
    >
      <el-form :model="form" label-width="120px" :rules="rules" ref="ratioForm">
        <el-form-item label="分成项目" prop="divide_item" required>
          <el-select v-model="form.divide_item" placeholder="请选择分成项目" style="width: 100%">
            <el-option
              v-for="item in divideItemList"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分成模式" prop="divide_mode" required>
          <el-radio-group v-model="form.divide_mode">
            <el-radio :label="1">营业额</el-radio>
            <el-radio :label="2">利润</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="分成比例" prop="ratio" required>
          <el-input 
            v-model.number="form.ratio" 
            placeholder="请输入分成比例，如：0.5表示50%"
            type="number"
            :max="1"
            :min="0"
            step="0.01"
          >
            <template slot="append">比例</template>
          </el-input>
          <div style="color: #999; font-size: 12px; margin-top: 5px;">
            提示：输入0.5表示50%的分成比例，范围0-1
          </div>
        </el-form-item>
        <el-form-item label="排序" prop="sort_order">
          <el-input-number 
            v-model="form.sort_order" 
            :min="0" 
            :max="999"
            placeholder="排序值越大优先级越高"
          ></el-input-number>
          <div style="color: #999; font-size: 12px; margin-top: 5px;">
            提示：有多个配置时优先使用排序大的
          </div>
        </el-form-item>
        <el-form-item label="状态" prop="status" required>
          <el-radio-group v-model="form.status">
            <el-radio :label="1">可用</el-radio>
            <el-radio :label="0">不可用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button v-if="form.id" type="primary" @click="updateForm()">修 改</el-button>
        <el-button v-else type="primary" @click="submitForm()">添 加</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { ObjectChangedValue } from "@/js/utils";
import { unionRatioTypeList } from '../../dict.js';

export default {
  data() {
    return {
      divideItemList: unionRatioTypeList,
      form: {
        mechanism_id: this.$route.query.mechanism_id || null,
        invest_id: 0,
        divide_item: '',
        divide_mode: 1,
        ratio: 0,
        sort_order: 0,
        status: 1
      },
      temp: {},
      rules: {
        divide_item: [
          { required: true, message: '请选择分成项目', trigger: 'change' }
        ],
        divide_mode: [
          { required: true, message: '请选择分成模式', trigger: 'change' }
        ],
        ratio: [
          { required: true, message: '请输入分成比例', trigger: 'blur' },
          { 
            validator: (rule, value, callback) => {
              if (value === '' || value === null || value === undefined) {
                callback(new Error('请输入分成比例'));
              } else if (value < 0 || value > 1) {
                callback(new Error('分成比例必须在0-1之间'));
              } else {
                callback();
              }
            }, 
            trigger: 'blur' 
          }
        ],
        status: [
          { required: true, message: '请选择状态', trigger: 'change' }
        ]
      },
      dialogVisible: false
    };
  },

  methods: {
    open(info) {
      if (info && info.id) {
        // 编辑模式
        this.temp = Object.assign({}, info);
        this.form = Object.assign({}, info);
      } else {
        // 新增模式
        this.form = {
          mechanism_id: this.$route.query.mecID || null,
          divide_item: '',
          divide_mode: 1,
          ratio: 0,
          sort_order: 0,
          status: 1
        };
        this.temp = {};
      }
      this.dialogVisible = true;
      // 重置表单验证
      this.$nextTick(() => {
        if (this.$refs.ratioForm) {
          this.$refs.ratioForm.clearValidate();
        }
      });
    },
    updateForm() {
      this.$refs.ratioForm.validate((valid) => {
        if (valid) {
          this.updateRatio();
        }
      });
    },
    submitForm() {
      this.$refs.ratioForm.validate((valid) => {
        if (valid) {
          this.addNew();
        }
      });
    },
    addNew() {
      let url = "/user/unionMechanismRatio/insert";
      
      this.$axios.post(url, this.form).then((res) => {
        this.$message({ type: "success", message: "添加成功!" });
        this.dialogVisible = false;
        this.$emit("success");
      });
    },
    updateRatio() {
      let data = ObjectChangedValue(this.temp, this.form);
      data.id = this.form.id;
      data.divide_item = this.form.divide_item
      data.mechanism_id = this.form.mechanism_id
      let url = "/user/unionMechanismRatio/update";
      
      this.$axios.post(url, data).then((res) => {
        this.$message({ type: "success", message: "修改成功!" });
        this.dialogVisible = false;
        this.temp = {};
        this.$emit("success");
      });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
